export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9254.66e46af9.jpg";